import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { LogoBar as LogoBarZDS } from '@zapier/design-system';
export function LogoBarV2({ title, items, size }) {
    return _jsx(LogoBarZDS, { title: title, items: items, size: size });
}
//# sourceMappingURL=LogoBarV2.js.map